import React, { useState, createContext, useContext } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import AuthModal from './AuthModal';
import '../styles/Layout.css';

// Lets any page inside Layout open the auth modal (e.g. homepage CTAs)
const AuthModalContext = createContext(() => {});
export const useAuthModal = () => useContext(AuthModalContext);

function Layout({ children }) {
  const [authModal, setAuthModal] = useState({ open: false, tab: 'login' });

  const openAuth = (tab = 'login') => {
    setAuthModal({ open: true, tab });
  };

  const closeAuth = () => {
    setAuthModal({ open: false, tab: 'login' });
  };

  return (
    <div className="layout">
      <Navbar onOpenAuth={openAuth} />
      <main className="layout-main">
        <AuthModalContext.Provider value={openAuth}>
          {children}
        </AuthModalContext.Provider>
      </main>
      <Footer />
      {authModal.open && (
        <AuthModal
          initialTab={authModal.tab}
          onClose={closeAuth}
        />
      )}
    </div>
  );
}

export default Layout;
